// Schvaľovacie úrovne L1..L8 — frontendový náprotivok backend/src/lib/levels.js.
// Držať v zhode: reťazec úrovní ('l1', 'l1_l2', 'l1_l2_l3') je to isté kódovanie
// v DB, v API aj tu.

export const MAX_LEVEL = 8;

const FALLBACK_CHAIN = [1, 2];

// 'l1_l2' → [1, 2]
export function parseChain(requiredLevel?: string | null): number[] {
  if (!requiredLevel) return [...FALLBACK_CHAIN];
  const raw = String(requiredLevel).trim().toLowerCase();
  if (!raw) return [...FALLBACK_CHAIN];
  if (raw === '1') return [1];
  if (raw === '2') return [1, 2];

  const levels: number[] = [];
  for (const part of raw.split('_')) {
    const m = /^l(\d+)$/.exec(part.trim());
    if (!m) return [...FALLBACK_CHAIN];
    const n = parseInt(m[1], 10);
    if (!Number.isInteger(n) || n < 1 || n > MAX_LEVEL) return [...FALLBACK_CHAIN];
    if (!levels.includes(n)) levels.push(n);
  }
  if (levels.length === 0) return [...FALLBACK_CHAIN];
  return levels.sort((a, b) => a - b);
}

// [1, 2] → 'l1_l2'
export function formatChain(levels: number[]): string {
  const uniq = Array.from(new Set(levels.filter(n => Number.isInteger(n) && n >= 1 && n <= MAX_LEVEL)))
    .sort((a, b) => a - b);
  if (uniq.length === 0) return formatChain(FALLBACK_CHAIN);
  return uniq.map(n => `l${n}`).join('_');
}

// 'awaiting_l3' → 3
export function levelFromStatus(status?: string | null): number | null {
  const m = /^awaiting_l(\d+)$/.exec(String(status || ''));
  if (!m) return null;
  const n = parseInt(m[1], 10);
  return n >= 1 && n <= MAX_LEVEL ? n : null;
}

// 'approver_l3' → 3
export function levelFromRole(role?: string | null): number | null {
  const m = /^approver_l(\d+)$/.exec(String(role || ''));
  if (!m) return null;
  const n = parseInt(m[1], 10);
  return n >= 1 && n <= MAX_LEVEL ? n : null;
}

export function roleForLevel(level: number): string {
  return `approver_l${level}`;
}

export function roleLabel(level: number): string {
  return `Schvaľovateľ L${level}`;
}

// Farba úrovne — L1 oranžová a L2 modrá ostávajú ako doteraz, vyššie úrovne
// pokračujú v palete. Pri viac než 8 úrovniach sa cyklí (nemá nastať).
const LEVEL_COLORS = ['#d97706', '#2563eb', '#7c3aed', '#db2777', '#0891b2', '#65a30d', '#ea580c', '#4f46e5'];
export function levelColor(level: number): string {
  return LEVEL_COLORS[(level - 1) % LEVEL_COLORS.length];
}

// Zoznam úrovní na výber v UI — podľa nastavenia firmy (tenants.approval_levels).
export function levelOptions(count: number): number[] {
  const n = Math.min(Math.max(parseInt(String(count), 10) || 2, 1), MAX_LEVEL);
  return Array.from({ length: n }, (_, i) => i + 1);
}
